'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HellosignLayout = HellosignLayout;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('ui/blocks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function HellosignLayout(_ref) {
    var children = _ref.children,
        responsive = _ref.responsive;

    var style = responsive ? {} : { minWidth: 1180 };

    // The 'site-wrapper' is needed as a js-hook for the notifications component
    return _react2['default'].createElement(
        _blocks.Flex,
        {
            id: 'site-wrapper',
            style: style,
            flexDirection: 'column',
            className: 'hellosign-layout-container',
            marginX: 'auto',
            px: responsive ? 3 : 1 },
        children
    );
}

exports['default'] = HellosignLayout;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/common/layout/layout.jsx
 ** module id = 1194
 ** module chunks = 0 1
 **/